import React, { FC } from 'react'

import Button from 'components/Button'
import ButtonNew from 'components/ButtonNew'

import { useStore } from 'store'

interface IProps {
  onClick: () => void
  text: React.ReactNode
  isDisabled?: boolean
  buttonType?: 'old' | 'buttonNew'
  type?: 'button' | 'submit'
  w100?: boolean
}

export const WidgetButton: FC<IProps> = ({
  onClick,
  text,
  isDisabled,
  buttonType = 'buttonNew',
  type = 'button',
  w100 = true,
}) => {
  const { widget } = useStore()

  if (buttonType === 'old') {
    return (
      <Button
        type="button"
        style={{
          padding: '0.5rem 1rem',
          height: 50,
          width: w100 ? '100%' : '',
          background:
            widget?.theme?.themeButtonBG ||
            'linear-gradient(131.69deg, #1f45c3 6.46%, #0e219b 100%)',
          boxShadow: 'none',
        }}
        styleText={{
          color: widget?.theme?.themeButtonColor || '#ffffff',
        }}
        btnStyle={'classic'}
        text={text as string}
        onClick={onClick}
        blueHover={!widget?.theme?.themeButtonBG}
      />
    )
  }

  return (
    <ButtonNew
      btnType={type}
      onClick={onClick}
      btnStyleType={'style_6'}
      btnText={text}
      btnStyle={{
        padding: '0.5rem 1rem',
        height: 50,
        width: w100 ? '100%' : '',
        background: widget?.theme?.themeButtonBG || '',
      }}
      btnTextStyle={{
        color: widget?.theme?.themeButtonColor || '',
      }}
      isDisabled={isDisabled}
    />
  )
}

WidgetButton.displayName = 'WidgetButton'

export default React.memo(WidgetButton)
